import { render, staticRenderFns } from "./ExperimentForm.vue?vue&type=template&id=31f45885&scoped=true&"
import script from "./ExperimentForm.vue?vue&type=script&lang=js&"
export * from "./ExperimentForm.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentForm.vue?vue&type=style&index=0&id=31f45885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f45885",
  null
  
)

export default component.exports